import { validatePdfFormatFile } from '../helpers/validation';

function processWhenFilesAreMoreThanFive(fields, filesArray, callback) {
    if (
        filesArray.some((fileFromArray) =>
            fields.value.find((file) => file.value.name === fileFromArray.name),
        )
    ) {
        alert('Plik o takiej nazwie już istnieje');
    } else if (fields.value.length >= 5 || filesArray.length > 5) {
        alert('Możesz dodać maksymalnie 5 plików');
    } else {
        callback();
    }
}

function addFiles(filesArray, fields, callback) {
    const fieldsLength = fields.value.length;

    filesArray.forEach((file) => {
        // if (validatePdfFormatFile(file) && fieldsLength < 5) {
        callback(file);
        // fieldsLength += 1;
        // }
    });
}

export const useOnDrop = (callback, fields) => {
    const onDrop = (e) => {
        const filesArray = Array.from(e.dataTransfer.files);

        addFiles(filesArray, fields, callback);
        // processWhenFilesAreMoreThanFive(fields, filesArray, () => {
        //     addFiles(filesArray, fields, callback);
        // });
    };
    const onSelectFile = () => {
        const filesArray = Array.from(document.querySelector('.dropzoneFile').files);
        addFiles(filesArray, fields, callback);
        // processWhenFilesAreMoreThanFive(fields, filesArray, () => {
        // addFiles(filesArray, fields, callback);
        // });
    };

    return { onDrop, onSelectFile };
};
